import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {
    NzMessageService,
    NzUploadFile
} from 'ng-zorro-antd';
import {Observable, Observer} from "rxjs";
import {HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpResponse} from "@angular/common/http";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BaseService} from "../../../core";
@Component({
  selector: 'lc-upload-img',
  templateUrl: './lc-upload-img.component.html',
    styleUrls: ['./lc-upload-img.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LcUploadImgComponent),
            multi: true,
        }
        ],
})
  export class LcUploadImgComponent extends BaseService  implements ControlValueAccessor {
    @Input()
    lcAction="metabase/dynamicFile/upload";
    @Input()
    lcGetAction="metabase/dynamicFile/getFile";
    @Input()
    lcFileType="image/png,image/jpeg,image/gif,image/bmp";
    get action() {
           return this.fUrl(this.lcAction);
    }
    loading = false;
    imgUrl?: string;
    responseData: any;
    _value: any;
    get value(){
        return this._value;
    }
    set value(value) {
        this._value = value;
        if (value) {
            this.imgUrl = `${this.fUrl(this.lcGetAction)}?fileKey=${this.value}`;
        } else {
            this.imgUrl = undefined;
        }
        console.log(this.imgUrl);
    }

    @Output() c8OnChange = new EventEmitter<any>();
    private onChangeFn: (val: string) => void;
    private onTouchedFn: () => void;

    constructor(private msg: NzMessageService,
                private http: HttpClient
    ) {
        super();
    }

    beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
        return new Observable((observer: Observer<boolean>) => {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.msg.error('You can only upload JPG file!');
                observer.complete();
                return;
            }
            const isLt2M = file.size! / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.msg.error('Image must smaller than 2MB!');
                observer.complete();
                return;
            }
            observer.next(isJpgOrPng && isLt2M);
            observer.complete();
        });
    };

    private getBase64(img: File, callback: (img: string) => void): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result!.toString()));
        reader.readAsDataURL(img);
    }

    handleChange(info: { file: NzUploadFile }): void {
        switch (info.file.status) {
            case 'uploading':
                this.loading = true;
                this.value="";
                break;
            case 'done':
                this.loading = false;
                // Get this url from response in real world.
                // this.getBase64(info.file!.originFileObj!, (img: string) => {
                //     this.loading = false;
                //     this.imgUrl = img;
                // });
                break;
            case 'error':
                this.msg.error('Network error');
                this.loading = false;
                break;
        }
    }
    remove(e:Event){
         this.value="";
         e.stopPropagation();
    }

    view(e:Event){
        const url=`${window.location.origin}/#/dynamic/viewImage?imgUrl=${encodeURIComponent(this.imgUrl)}`;
        window.open(url,'图片预览','width=300');
        e.stopPropagation();
    }

    customReq = (item) => {
        // this.fileStatus = false;
        // this.responseData = [];
        // 构建一个 FormData 对象，用于存储文件或其他参数
        const formData = new FormData();
        // tslint:disable-next-line:no-any
        formData.append('file', item.file as any);
        formData.append("moduleName", "testModule");
        const req = new HttpRequest('POST', item.action!, formData, {
            reportProgress: true,
            withCredentials: true
        });
        // 始终返回一个 `Subscription` 对象，nz-upload 会在适当时机自动取消订阅
        return this.http.request(req).subscribe(
            (event: HttpEvent<{}>) => {
                if (event.type === HttpEventType.UploadProgress) {
                    if (event.total! > 0) {
                        // tslint:disable-next-line:no-any
                        (event as any).percent = (event.loaded / event.total!) * 100;
                    }
                    // 处理上传进度条，必须指定 `percent` 属性来表示进度
                    item.onProgress!(event, item.file!);
                } else if (event instanceof HttpResponse) {
                    // 处理成功
                    // this.fileStatus = true;
                    this.responseData = event.body;
                    this.value = this.responseData.result;
                    this.change(this.value);
                    console.log(this.responseData);
                    // this.filePath = this.responseData.data;
                    item.onSuccess!(event.body, item.file!, event);
                }
            },
            err => {
                // 处理失败
                item.onError!(err, item.file!);
            }
        );
    };

    change(value: any): void {
        this.onChangeFn(value);
        this.c8OnChange.emit(value);
    }

    writeValue(value: string): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }
}
